module.exports = __webpack_public_path__ + "img/h-page4-42.1402660b.png";